import React from 'react';
import styled from 'styled-components';

// Services
import { useParams } from 'react-router';
import { Box, HStack } from '@wegroup/design-system';
import { useFlowsSelector } from '../../../../common/src/utils/globalVariables';

const ProgressBar: React.FC<React.PropsWithChildren<unknown>> = ({
  ...otherProps
}) => {
  const questionnaire = useFlowsSelector((state) => state.flows.questionnaire);
  const position = parseInt(useParams<{ position: string }>().position);

  const lastPositions = Object.assign(
    {},
    ...questionnaire.groups.map(({ tag }, index: number) => ({ [tag]: index })),
  ) as { [x: string]: number };

  return (
    <Container data-test-id="ProdFac_ProgressBar" {...otherProps}>
      <HStack spacing="1">
        {Object.entries(lastPositions).map(([tag, lastPosition]) => {
          const firstPosition = questionnaire.groups.findIndex(
            ({ tag: _tag }) => tag === _tag,
          );
          const isCurrentStep =
            position >= firstPosition && position <= lastPosition;
          const isPastStep = position > lastPosition;
          return (
            <Box
              display="inline-block"
              w={isCurrentStep ? '100%' : '50%'}
              bg={
                isCurrentStep
                  ? 'secondary.850'
                  : isPastStep
                  ? 'secondary.700'
                  : 'secondary.600'
              }
              key={tag}
              transition="0.5s"
              borderRadius="full"
              h="0.6rem"
            />
          );
        })}
      </HStack>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

export default ProgressBar;
